import { ThemeTypes } from './themeManage';

/**
 * 本地存储可能被旧版本或宿主页面写入非法值，必须回退到主题模块的单一默认值。
 */
export const resolveTheme = (storedTheme: unknown, defaultTheme: ThemeTypes): ThemeTypes => {
  if (typeof storedTheme === 'string' && Object.values(ThemeTypes).includes(storedTheme as ThemeTypes)) {
    return storedTheme as ThemeTypes;
  }
  return defaultTheme;
};
